import { render, staticRenderFns } from "./single-card.vue?vue&type=template&id=76ad974a&"
import script from "./single-card.vue?vue&type=script&lang=js&"
export * from "./single-card.vue?vue&type=script&lang=js&"
import style0 from "./single-card.vue?vue&type=style&index=0&id=76ad974a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports